import { Course, CourseEnrollment } from '../types';

export const mockCourses: Course[] = [
  {
    id: 'course_1',
    title: 'Lean Startup: De la Idea al Producto',
    description: 'Aprende a validar tu idea de negocio usando la metodología Lean Startup',
    category: 'Emprendimiento',
    level: 'Básico',
    recommendedFor: ['Idea', 'Validación'],
    contents: [
      {
        id: 'content_1_1',
        title: 'Introducción al Lean Startup',
        type: 'Video',
        url: '/courses/lean-startup/intro.mp4',
        duration: 15,
        order: 1
      },
      {
        id: 'content_1_2',
        title: 'Build-Measure-Learn',
        type: 'Video',
        url: '/courses/lean-startup/bml.mp4',
        duration: 20,
        order: 2
      },
      {
        id: 'content_1_3',
        title: 'Validación de Hipótesis',
        type: 'PDF',
        url: '/courses/lean-startup/validation.pdf',
        duration: 30,
        order: 3
      }
    ],
    thumbnail: '/thumbnails/lean-startup.jpg',
    duration: 65,
    createdBy: 'user_admin_1',
    createdAt: '2024-01-01T10:00:00Z'
  },
  {
    id: 'course_2',
    title: 'Marketing Digital para Startups',
    description: 'Estrategias efectivas de marketing digital con presupuesto limitado',
    category: 'Marketing',
    level: 'Intermedio',
    recommendedFor: ['Validación', 'Crecimiento Temprano'],
    contents: [
      {
        id: 'content_2_1',
        title: 'Fundamentos de Marketing Digital',
        type: 'Video',
        url: '/courses/marketing/fundamentos.mp4',
        duration: 25,
        order: 1
      },
      {
        id: 'content_2_2',
        title: 'SEO y SEM para Startups',
        type: 'Video',
        url: '/courses/marketing/seo-sem.mp4',
        duration: 30,
        order: 2
      },
      {
        id: 'content_2_3',
        title: 'Redes Sociales y Content Marketing',
        type: 'Video',
        url: '/courses/marketing/social-media.mp4',
        duration: 25,
        order: 3
      }
    ],
    thumbnail: '/thumbnails/marketing-digital.jpg',
    duration: 80,
    createdBy: 'user_admin_1',
    createdAt: '2024-01-15T10:00:00Z'
  },
  {
    id: 'course_3',
    title: 'Finanzas para Emprendedores',
    description: 'Gestión financiera y búsqueda de inversión para tu startup',
    category: 'Finanzas',
    level: 'Intermedio',
    recommendedFor: ['Validación', 'Crecimiento Temprano', 'Escalamiento'],
    contents: [
      {
        id: 'content_3_1',
        title: 'Fundamentos Financieros',
        type: 'Video',
        url: '/courses/finanzas/fundamentos.mp4',
        duration: 20,
        order: 1
      },
      {
        id: 'content_3_2',
        title: 'Modelos Financieros',
        type: 'PDF',
        url: '/courses/finanzas/modelos.pdf',
        duration: 40,
        order: 2
      },
      {
        id: 'content_3_3',
        title: 'Pitch a Inversores',
        type: 'Video',
        url: '/courses/finanzas/pitch.mp4',
        duration: 30,
        order: 3
      }
    ],
    thumbnail: '/thumbnails/finanzas.jpg',
    duration: 90,
    createdBy: 'user_admin_1',
    createdAt: '2024-02-01T10:00:00Z'
  },
  {
    id: 'course_4',
    title: 'Desarrollo de MVP Tecnológico',
    description: 'Cómo construir tu Producto Mínimo Viable de forma eficiente',
    category: 'Tecnología',
    level: 'Avanzado',
    recommendedFor: ['Idea', 'Validación'],
    contents: [
      {
        id: 'content_4_1',
        title: 'Qué es un MVP',
        type: 'Video',
        url: '/courses/mvp/intro.mp4',
        duration: 15,
        order: 1
      },
      {
        id: 'content_4_2',
        title: 'Metodologías Ágiles',
        type: 'Video',
        url: '/courses/mvp/agile.mp4',
        duration: 25,
        order: 2
      },
      {
        id: 'content_4_3',
        title: 'Herramientas No-Code/Low-Code',
        type: 'Artículo',
        url: '/courses/mvp/tools.html',
        duration: 20,
        order: 3
      }
    ],
    thumbnail: '/thumbnails/mvp.jpg',
    duration: 60,
    createdBy: 'user_admin_2',
    createdAt: '2024-02-15T10:00:00Z'
  },
  {
    id: 'course_5',
    title: 'Pitch Perfect: Comunica tu Idea',
    description: 'Aprende a crear y presentar un pitch efectivo',
    category: 'Comunicación',
    level: 'Básico',
    recommendedFor: ['Idea', 'Validación', 'Crecimiento Temprano'],
    contents: [
      {
        id: 'content_5_1',
        title: 'Estructura de un Pitch',
        type: 'Video',
        url: '/courses/pitch/estructura.mp4',
        duration: 20,
        order: 1
      },
      {
        id: 'content_5_2',
        title: 'Storytelling para Emprendedores',
        type: 'Video',
        url: '/courses/pitch/storytelling.mp4',
        duration: 25,
        order: 2
      }
    ],
    thumbnail: '/thumbnails/pitch.jpg',
    duration: 45,
    createdBy: 'user_admin_1',
    createdAt: '2024-03-01T10:00:00Z'
  }
];

export const mockEnrollments: CourseEnrollment[] = [
  {
    id: 'enroll_1',
    userId: 'user_emprendedor_1',
    courseId: 'course_1',
    enrolledAt: '2024-02-01T10:00:00Z',
    progress: 100,
    completedContents: ['content_1_1', 'content_1_2', 'content_1_3'],
    lastAccessedAt: '2024-03-15T10:00:00Z'
  },
  {
    id: 'enroll_2',
    userId: 'user_emprendedor_1',
    courseId: 'course_3',
    enrolledAt: '2024-03-01T10:00:00Z',
    progress: 66,
    completedContents: ['content_3_1', 'content_3_2'],
    lastAccessedAt: '2024-04-10T10:00:00Z'
  },
  {
    id: 'enroll_3',
    userId: 'user_emprendedor_2',
    courseId: 'course_2',
    enrolledAt: '2024-02-15T10:00:00Z',
    progress: 100,
    completedContents: ['content_2_1', 'content_2_2', 'content_2_3'],
    lastAccessedAt: '2024-04-01T10:00:00Z'
  },
  {
    id: 'enroll_4',
    userId: 'user_emprendedor_2',
    courseId: 'course_5',
    enrolledAt: '2024-03-10T10:00:00Z',
    progress: 50,
    completedContents: ['content_5_1'],
    lastAccessedAt: '2024-04-05T10:00:00Z'
  },
  {
    id: 'enroll_5',
    userId: 'user_emprendedor_3',
    courseId: 'course_1',
    enrolledAt: '2024-03-15T10:00:00Z',
    progress: 33,
    completedContents: ['content_1_1'],
    lastAccessedAt: '2024-04-12T10:00:00Z'
  },
  {
    id: 'enroll_6',
    userId: 'user_emprendedor_3',
    courseId: 'course_4',
    enrolledAt: '2024-03-20T10:00:00Z',
    progress: 0,
    completedContents: [],
    lastAccessedAt: '2024-03-20T10:00:00Z'
  },
  {
    id: 'enroll_7',
    userId: 'user_emprendedor_4',
    courseId: 'course_3',
    enrolledAt: '2024-02-10T10:00:00Z',
    progress: 100,
    completedContents: ['content_3_1', 'content_3_2', 'content_3_3'],
    lastAccessedAt: '2024-03-30T10:00:00Z'
  },
  {
    id: 'enroll_8',
    userId: 'user_emprendedor_4',
    courseId: 'course_1',
    enrolledAt: '2024-02-05T10:00:00Z',
    progress: 66,
    completedContents: ['content_1_1', 'content_1_2'],
    lastAccessedAt: '2024-04-08T10:00:00Z'
  }
];
